import dayjs from "dayjs";
import { Modal } from "bootstrap";

import { getCsrfToken } from "@phoarau/ts_sysop_utils";
import { emitAcknowledged, renderNewsBadge } from "../composants/ReleaseNoteSync";
import { ReleaseNote } from "../Models/ReleaseNote";

const MODAL_ID = "ReleaseNoteModal";

type UnseenResponse = {
    /** Notes non lues assez recentes pour s'imposer au chargement. */
    notes: ReleaseNote[];
    /** Total non lu, anciennes comprises : alimente la pastille du header. */
    unread_total: number;
};

function formatDate(publishedAt: string | null): string {
    return publishedAt ? dayjs(publishedAt).format("D MMMM YYYY") : "";
}

/**
 * Rend le lot dans la modal. Une seule note occupe l'en-tete comme avant ;
 * au-dela, l'en-tete annonce le nombre et chaque note devient une section du
 * corps, dans un unique defilement.
 */
function renderNotes(notes: ReleaseNote[]): void {
    const $modal = $("#" + MODAL_ID);
    const $notes = $modal.find('[data-release-note="notes"]').empty();
    const single = notes.length === 1;

    $modal.find('[data-release-note="eyebrow"]').text(single ? "Nouveauté" : `${notes.length} nouveautés`);
    $modal.find('[data-release-note="date"]').text(single ? formatDate(notes[0].published_at) : "");
    $modal
        .find('[data-release-note="title"]')
        .text(single ? notes[0].title : `${notes.length} nouveautés depuis votre dernière visite`);

    notes.forEach((note) => {
        // Le HTML du corps est rendu et assaini cote serveur (ReleaseNoteRenderer).
        const $content = $('<div class="release-note-content">').html(note.content_html);

        if (single) {
            $notes.append($content);

            return;
        }

        $notes.append(
            $('<section class="rn-modal__note">')
                .append($('<div class="rn-modal__note-date">').text(formatDate(note.published_at)))
                .append($('<h3 class="rn-modal__note-title">').text(note.title))
                .append($content),
        );
    });
}

/**
 * Recupere le lot non lu et l'affiche. La modal est bloquante (backdrop
 * statique, sans bouton de fermeture) : la seule sortie « J'ai compris »
 * acquitte cote serveur les notes qui viennent d'etre presentees.
 */
function showUnseen(): void {
    const modalEl = document.getElementById(MODAL_ID);
    if (!modalEl) {
        return;
    }

    $.ajax({
        url: "/release-notes/unseen.json",
        type: "GET",
        cache: false,
        dataType: "json",
        success: (response: UnseenResponse) => {
            const notes = response?.notes ?? [];

            renderNewsBadge(response?.unread_total ?? 0);

            if (notes.length === 0) {
                return;
            }

            renderNotes(notes);
            $(modalEl).data(
                "releaseNoteIds",
                notes.map((note) => note.id),
            );

            Modal.getOrCreateInstance(modalEl, { backdrop: "static", keyboard: false }).show();
        },
    });
}

/**
 * Acquitte en un appel le lot presente. Rien n'est marque vu au-dela : les
 * notes trop anciennes pour la modal restent non lues jusqu'a ce que
 * l'utilisateur les rattrape depuis le journal de bord.
 */
function acknowledge(): void {
    const modalEl = document.getElementById(MODAL_ID);
    if (!modalEl) {
        return;
    }

    const ids: number[] = $(modalEl).data("releaseNoteIds") ?? [];
    if (ids.length === 0) {
        Modal.getOrCreateInstance(modalEl).hide();

        return;
    }

    $.ajax({
        url: "/release-notes/mark-viewed.json",
        type: "POST",
        cache: false,
        headers: { "X-CSRF-Token": getCsrfToken() },
        data: { ids },
        dataType: "json",
        success: (result: { status: number; unread_total?: number }) => {
            renderNewsBadge(result?.unread_total ?? 0);
            $(modalEl).removeData("releaseNoteIds");

            // La modal peut s'ouvrir par-dessus le journal de bord : il doit
            // retirer les marqueurs « Non lu » des notes qu'on vient d'acquitter.
            emitAcknowledged(ids);

            Modal.getOrCreateInstance(modalEl).hide();
        },
    });
}

$(function () {
    if (document.location.pathname === "/users/login") {
        return;
    }

    $("#" + MODAL_ID).on("click", ".btn-release-ack", acknowledge);

    showUnseen();
});
